import React from "react";
import { Card, CardContent } from "./ui/card";
import { FileText, Building2 } from "lucide-react";

const EmptyStateMessage = () => {
  return (
    <Card className="w-full max-w-md mx-auto border border-white ">
      <CardContent className="flex flex-col items-center justify-center py-16">
        <div className="flex items-center justify-center space-x-2 p-4 bg-gray-50 rounded-full mb-4">
          <FileText className="w-6 h-6 text-gray-400" />
          <Building2 className="w-6 h-6 text-gray-400" />
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">
          Nie sú vybrané žiadne údaje
        </h3>
        <p className="text-sm text-gray-500 text-center max-w-sm">
          Prosím, vyberte situáciu a pobočku pre zobrazenie výsledkov
          hodnotenia.
        </p>
      </CardContent>
    </Card>
  );
};

export default EmptyStateMessage;
